import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const mutations = {
    info_save: (state, user) => {
      state.info=user
      // 把登录的用户的名保存到localStorage中，防止页面刷新，导致vuex重新启动，用户名就成为初始值（初始值为空）的情况
      localStorage.setItem('info', JSON.stringify(user))
    }
}
const state = {
  info: '' || JSON.parse(localStorage.getItem('info'))
}

// // getters 只会依赖 state 中的成员去更新
// const getters = {
//     info: (state) => state.info
// }


const store = new Vuex.Store({
  mutations,
  state,
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js